
export const JOBS_FRIEND_GET              = "JOBS_FRIEND_GET"
export const JOBS_FRIEND_SET              = "JOBS_FRIEND_SET"

export const JOBS_FRIEND_CHECK_GET              = "JOBS_FRIEND_CHECK_GET"
export const JOBS_FRIEND_CHECK_SET              = "JOBS_FRIEND_CHECK_SET"